import { render, staticRenderFns } from "./ShowProgram.vue?vue&type=template&id=3547b23c&scoped=true"
import script from "./ShowProgram.vue?vue&type=script&lang=js"
export * from "./ShowProgram.vue?vue&type=script&lang=js"
import style0 from "./ShowProgram.vue?vue&type=style&index=0&id=3547b23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547b23c",
  null
  
)

export default component.exports